var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-skeleton-loader',{staticClass:"mb-6",attrs:{"loading":true,"types":_vm.skeleton,"type":"article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }